<template>
  <div class="reviews-page">
    <Toast position="top-center" />
    <EstablishmentsModal
      v-if="showEstablishmentsModal"
      :isOpen="showEstablishmentsModal"
      :selectedCategory="selectedCategory"
      :establishmentsData="establishmentsData"
      :categoryFilter="selectedCategoryFilter"
      @close="closeEstablishmentsModal"
      @clear-category-filter="clearCategoryFilter"
    />
    <TrendsModal
      v-if="showTrendsModal"
      :isOpen="showTrendsModal"
      :selectedSector="selectedSectorForTrends"
      :sectorData="sectorTrendsData"
      @close="closeTrendsModal"
    />
    <ActionPlanModal
      v-if="showActionPlanModal"
      :isOpen="showActionPlanModal"
      :categoryData="this[selectedCategoryForAction]"
      :categoryName="selectedCategoryNameForAction"
      :month="selectedMonthForAction"
      :year="selectedYearForAction"
      @close="closeActionPlanModal"
    />
    <div class="profile-container">
      <div class="header-content">
        <h1 style="font-size: 34px; padding-top: 30px"><strong>Análise de Reviews</strong></h1>
        <p style="font-size: 14px; padding-top: 50px">Fontes: Google Places</p>
      </div>
      <div class="profile-content">
        <div class="left-content">
          <div class="profile-block">
            <span class="title-content">Análise temporal das avaliações</span>
            <div>
              <button
                class="btn-chart"
                :class="selectedChartButton == 'myChartYearly' ? 'selected' : ''"
                @click="selectChartButton('myChartYearly')"
              >
                Comparativo anual
              </button>
              <button
                class="btn-chart"
                :class="selectedChartButton == 'myChartMonthly' ? 'selected' : ''"
                @click="selectChartButton('myChartMonthly')"
              >
                Comparativo mensal
              </button>
            </div>
            
            <div v-if="selectedChartButton == 'myChartMonthly' && !isLoadingReviews" style="margin-top: 10px; display: flex; justify-content: center; gap: 10px;">
              <button 
                v-for="year in availableYears" 
                :key="year"
                class="btn-year"
                :class="selectedYearMonthly == year ? 'selected' : ''"
                @click="selectYearMonthly(year)"
              >
                {{ year }}
              </button>
            </div>

            <div v-if="isLoadingReviews">
              <Skeleton width="10rem" class="mb-2"></Skeleton>
              <Skeleton width="5rem" class="mb-2"></Skeleton>
              <Skeleton height=".5rem"></Skeleton>
            </div>
            <div v-if="isLoadingReviews">
              <Skeleton width="10rem" class="mb-2"></Skeleton>
              <Skeleton width="5rem" class="mb-2"></Skeleton>
              <Skeleton height=".5rem"></Skeleton>
            </div>
            <canvas
              style="padding: 0 10px"
              id="myChartYearly"
              class="chart"
              v-if="!isLoadingReviews && selectedChartButton === 'myChartYearly'"
              ref="yearlyChart"
            ></canvas>
            <canvas
              style="padding: 0 10px"
              id="myChartMonthly"
              class="chart"
              v-if="!isLoadingReviews && selectedChartButton === 'myChartMonthly'"
              ref="monthlyChart"
            ></canvas>
            <img 
              v-if="!isLoadingReviews" 
              src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" 
              style="display:none" 
              @load="forceChartDisplay" 
              alt=""
            />
          </div>

          <div class="profile-block">
            <span class="title-content">Sentimento das Avaliações</span>
            <span class="second-title-content" v-if="!isLoadingReviews">{{ predominantSentiment.sentiment }}</span>
            <span class="subtitle-content" v-if="!isLoadingReviews">É o sentimento mais presente em avaliações</span>
            <div v-if="isLoadingReviews">
              <Skeleton width="10rem" class="mb-2"></Skeleton>
              <Skeleton width="5rem" class="mb-2"></Skeleton>
              <Skeleton height=".5rem"></Skeleton>
            </div>
            <canvas id="secondChart" class="chart" v-if="!isLoadingReviews" style="cursor: pointer;"></canvas>
            <img 
              v-if="!isLoadingReviews" 
              src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" 
              style="display:none" 
              @load="forceSecondChartDisplay" 
              alt=""
            />
            <div
              v-if="!isLoadingReviews"
              class="sentiment-legend-container"
              style="
                display: flex;
                align-items: center;
                justify-content: space-around;
                margin: 15px 0;
                gap: 10px;
              "
            >
              <button 
                class="sentiment-legend-button"
                @click="openEstablishmentsModal('negative')"
                style="
                  display: flex;
                  align-items: center;
                  background-color: #f25362;
                  border: none;
                  padding: 8px 16px;
                  border-radius: 20px;
                  cursor: pointer;
                  color: white;
                  font-size: 12px;
                  font-weight: 600;
                  box-shadow: 0 2px 4px rgba(242, 83, 98, 0.2);
                  position: relative;
                  overflow: hidden;
                "
                @mouseover="$event.target.style.opacity = '0.8'"
                @mouseout="$event.target.style.opacity = '1'"
              >
                <font-awesome-icon
                  icon="fa-solid fa-face-frown"
                  style="margin-right: 7px; color: white;"
                  size="lg"
                />Negativo ({{ predominantSentiment.counts.negative }})
              </button>
              <button 
                class="sentiment-legend-button"
                @click="openEstablishmentsModal('neutral')"
                style="
                  display: flex;
                  align-items: center;
                  background-color: #ffc700;
                  border: none;
                  padding: 8px 16px;
                  border-radius: 20px;
                  cursor: pointer;
                  color: white;
                  font-size: 12px;
                  font-weight: 600;
                  box-shadow: 0 2px 4px rgba(255, 199, 0, 0.2);
                  position: relative;
                  overflow: hidden;
                "
                @mouseover="$event.target.style.opacity = '0.8'"
                @mouseout="$event.target.style.opacity = '1'"
              >
                <font-awesome-icon
                  icon="fa-solid fa-face-meh"
                  style="margin-right: 7px; color: white;"
                  size="lg"
                />Neutro ({{ predominantSentiment.counts.neutral }})
              </button>
              <button 
                class="sentiment-legend-button"
                @click="openEstablishmentsModal('positive')"
                style="
                  display: flex;
                  align-items: center;
                  background-color: #0b8c0b;
                  border: none;
                  padding: 8px 16px;
                  border-radius: 20px;
                  cursor: pointer;
                  color: white;
                  font-size: 12px;
                  font-weight: 600;
                  box-shadow: 0 2px 4px rgba(11, 140, 11, 0.2);
                  position: relative;
                  overflow: hidden;
                "
                @mouseover="$event.target.style.opacity = '0.8'"
                @mouseout="$event.target.style.opacity = '1'"
              >
                <font-awesome-icon
                  icon="fa-solid fa-face-smile"
                  style="margin-right: 7px; color: white;"
                  size="lg"
                />Positivo ({{ predominantSentiment.counts.positive }})
              </button>
            </div>
          </div>

          <div class="profile-block first-maps-blocks">
            <span class="title-content">Negócios Locais</span>
            <div v-if="isLoading" style="margin: 20px 0">
              <Skeleton width="10rem" class="mb-2"></Skeleton>
              <Skeleton width="5rem" class="mb-2"></Skeleton>
              <Skeleton height=".5rem"></Skeleton>
            </div>
            <div>
              <button 
                class="btn-map" 
                :class="selectedMapButton === 'all' ? 'selected' : ''"
                @click="selectMapButton('all')"
              >
                Todos os negócios
              </button>
              <button 
                class="btn-map" 
                :class="selectedMapButton === 'mostRated' ? 'selected' : ''"
                @click="selectMapButton('mostRated')"
              >
                Área mais avaliadas
              </button>
              <div v-if="isLoading" style="margin: 20px 0">
                <Skeleton width="10rem" class="mb-2"></Skeleton>
                <Skeleton width="5rem" class="mb-2"></Skeleton>
                <Skeleton height=".5rem"></Skeleton>
              </div>
              <div v-if="isLoading" style="margin: 20px 0">
                <Skeleton width="10rem" class="mb-2"></Skeleton>
                <Skeleton width="5rem" class="mb-2"></Skeleton>
                <Skeleton height=".5rem"></Skeleton>
              </div>
              <div id="map" class="container-map" v-if="!isLoading && selectedMapButton === 'all'"></div>
              <div id="secondMap" class="container-map" v-if="!isLoading && selectedMapButton === 'mostRated'"></div>
            </div>
          </div>
        </div>
        <div class="right-content">
          <div class="profile-block">
            <span class="title-content">Avaliação Média dos Setores</span>
            <p class="consulta-info" style="font-size: 12px" v-if="!isLoadingReviews">
              Consulta realizada em {{ this.query_date }}
            </p>
            <div v-if="isLoadingReviews">
              <Skeleton width="10rem" class="mb-2"></Skeleton>
              <Skeleton width="5rem" class="mb-2"></Skeleton>
              <Skeleton height=".5rem"></Skeleton>
            </div>
            <div v-if="isLoadingReviews">
              <Skeleton width="10rem" class="mb-2"></Skeleton>
              <Skeleton width="5rem" class="mb-2"></Skeleton>
              <Skeleton height=".5rem"></Skeleton>
            </div>
            <div v-if="isLoadingReviews">
              <Skeleton width="10rem" class="mb-2"></Skeleton>
              <Skeleton width="5rem" class="mb-2"></Skeleton>
              <Skeleton height=".5rem"></Skeleton>
            </div>
            <div v-if="isLoadingReviews">
              <Skeleton width="10rem" class="mb-2"></Skeleton>
              <Skeleton width="5rem" class="mb-2"></Skeleton>
              <Skeleton height=".5rem"></Skeleton>
            </div>
            <div v-if="isLoadingReviews">
              <Skeleton width="10rem" class="mb-2"></Skeleton>
              <Skeleton width="5rem" class="mb-2"></Skeleton>
              <Skeleton height=".5rem"></Skeleton>
            </div>
            <div v-if="isLoadingReviews">
              <Skeleton width="10rem" class="mb-2"></Skeleton>
              <Skeleton width="5rem" class="mb-2"></Skeleton>
              <Skeleton height=".5rem"></Skeleton>
            </div>
            <div class="profile-block-sector" v-if="!isLoadingReviews">
              <div class="rating-box">
                <div class="icon-container">
                  <img src="/chef.png" alt="Ícone de gastronomia" />
                </div>
                <div class="rating-info">
                  <span class="rating-info-content"
                    >{{ this.gastronomy.average_data['average_ratings'] }}/5</span
                  >
                  <span class="rating-info-title">Gastronomia</span>
                </div>
              </div>

              <div class="rating-box">
                <div class="icon-container">
                  <img src="/hospedagem.png" alt="Ícone de Hospedagem" />
                </div>
                <div class="rating-info">
                  <span class="rating-info-content"
                    >{{ this.lodging.average_data['average_ratings'] }}/5</span
                  >
                  <span class="rating-info-title">Hospedagem</span>
                </div>
              </div>

              <div class="rating-box">
                <div class="icon-container">
                  <img src="/atracoes.png" alt="Atrações" />
                </div>
                <div class="rating-info">
                  <span class="rating-info-content"
                    >{{ this.tour.average_data['average_ratings'] }}/5</span
                  >
                  <span class="rating-info-title">Atrações Turisticas</span>
                </div>
              </div>

              <div class="rating-box">
                <div class="icon-container">
                  <img src="/road.png" alt="Ícone de transporte" />
                </div>
                <div class="rating-info">
                  <span class="rating-info-content"
                    >{{ this.transport.average_data['average_ratings'] }}/5</span
                  >
                  <span class="rating-info-title">Transporte</span>
                </div>
              </div>

              <div class="rating-box">
                <div class="icon-container">
                  <img src="/noite.png" alt="Vida Noturna" />
                </div>
                <div class="rating-info">
                  <span class="rating-info-content"
                    >{{ this.nightlife.average_data['average_ratings'] }}/5</span
                  >
                  <span class="rating-info-title">Vida Noturna</span>
                </div>
              </div>
              <div class="rating-box">
                <div class="icon-container">
                  <img src="/bag.png" alt="Ícone de Comercio" />
                </div>
                <div class="rating-info">
                  <span class="rating-info-content"
                    >{{ this.commerce.average_data['average_ratings'] }}/5</span
                  >
                  <span class="rating-info-title">Comércio</span>
                </div>
              </div>
            </div>
          </div>

          <div class="profile-block">
            <span class="title-content">Palavras-chave em Alta</span>
            <span class="subtitle-content">Nos últimos 30 dias</span>
            <div
              class="border-round border-1 surface-border p-4 surface-card"
              v-if="isLoadingKeyWords"
            >
              <div class="flex mb-3">
                <Skeleton shape="circle" size="4rem" class="mr-2"></Skeleton>
                <div>
                  <Skeleton width="10rem" class="mb-2"></Skeleton>
                  <Skeleton width="5rem" class="mb-2"></Skeleton>
                  <Skeleton height=".5rem"></Skeleton>
                </div>
              </div>
              <Skeleton width="100%" height="150px"></Skeleton>
              <div class="flex justify-content-between mt-3">
                <Skeleton width="4rem" height="2rem"></Skeleton>
                <Skeleton width="4rem" height="2rem"></Skeleton>
              </div>
            </div>
            <div class="profile-block-pills" v-if="!isLoadingKeyWords">
              <div
                v-for="(keyword, index) in key_words.negative_keywords"
                :key="index + 'negative_keywords_profile'"
                style="background-color: #ff6666"
                class="profile-pill"
                :title="keyword[1] + ' Impressões'"
              >
                {{ keyword[0] }}
              </div>
              <div
                v-for="(keyword, index) in key_words.neutral_keywords"
                :key="index + 'neutral_keywords_profile'"
                style="background-color: #ffd700"
                class="profile-pill"
                :title="keyword[1] + ' Impressões'"
              >
                {{ keyword[0] }}
              </div>
              <div
                v-for="(keyword, index) in key_words.positive_keywords"
                :key="index + 'positive_keywords_profile'"
                style="background-color: #008000"
                class="profile-pill"
                :title="keyword[1] + ' Impressões'"
              >
                {{ keyword[0] }}
              </div>
            </div>
          </div>
          <div
            class="profile-block"
            style="height: 500px; overflow-y: auto"
            v-if="communProblems !== null"
          >
            <span class="title-content">Problemas Comuns</span>
            <div
              class="border-round border-1 surface-border p-4 surface-card"
              v-if="isLoadingComunsProblems"
            >
              <div class="flex mb-3">
                <Skeleton shape="circle" size="4rem" class="mr-2"></Skeleton>
                <div>
                  <Skeleton width="10rem" class="mb-2"></Skeleton>
                  <Skeleton width="5rem" class="mb-2"></Skeleton>
                  <Skeleton height=".5rem"></Skeleton>
                </div>
              </div>
              <Skeleton width="100%" height="150px"></Skeleton>
              <div class="flex justify-content-between mt-3">
                <Skeleton width="4rem" height="2rem"></Skeleton>
                <Skeleton width="4rem" height="2rem"></Skeleton>
              </div>
            </div>
            <div
              v-if="!isLoadingComunsProblems"
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 10px 0;
              "
            >
              <span> Reclamação </span>
              <span>Recorrência</span>
            </div>
            <div
              v-for="(problem, index) in communProblemsArray"
              v-if="!isLoadingComunsProblems"
              :key="index"
              style="
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                margin: 15px 0;
              "
            >
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin: 15px 0;
                "
              >
                <span style="font-size: 12px">
                  <strong>{{ problem.text }}</strong>
                </span>
                <span style="font-size: 12px">{{ problem.quantity }}</span>
              </div>
              <div>
                <div style="border: 1px solid #cad2d6; height: 2px; width: 100%"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SidebarMapData
      v-if="!isLoadingReviews"
      :isSidebarMapDataOpen.sync="isSidebarMapDataOpen"
      :reviewData="reviewData"
    />
    <ReviewsInsights :citiesString="citiesStringData" :roleIdProp="roleId" :states="states" />
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js'
import Toast from 'primevue/toast'

import Skeleton from 'primevue/skeleton'
import L from 'leaflet'
import axios from 'axios'
import 'leaflet/dist/leaflet.css'
import 'leaflet.heat/dist/leaflet-heat.js'
import Layout from './Layout.vue'
import SidebarMapData from './Components/SidebarMapData/SidebarMapData.vue'
import ReviewsInsights from './Components/Insights/ReviewsInsights.vue'
import StateCitySelector from './Components/StateCitySelector/StateCitySelector'
import EstablishmentsModal from './Components/EstablishmentsModal/EstablishmentsModal.vue'
import TrendsModal from './Components/TrendsModal/TrendsModal.vue'
import ActionPlanModal from './Components/ActionPlanModal/ActionPlanModal.vue'
Chart.register(...registerables)

export default {
  data() {
    return {
      citiesStringData: this.citiesString,
      changePage: false,
      loadingStates: false,
      loadingCities: false,
      stateSelected: null,
      selectedCity: null,
      states: [],
      isSidebarMapDataOpen: false,
      isLoading: true,
      isLoadingReviews: true,
      isLoadingKeyWords: true,
      isLoadingComunsProblems: true,
      selectedButton: 'mostRated',
      selectedChartButton: 'myChartYearly',
      selectedYearMonthly: new Date().getFullYear(),
      availableYears: [],
      communProblemsArray: [],
      reviewData: null,
      predominantSentiment: {
        sentiment: '',
        counts: {
          positive: 0,
          neutral: 0,
          negative: 0
        }
      },
      gastronomy: Object,
      lodging: Object,
      tour: Object,
      transport: Object,
      nightlife: Object,
      commerce: Object,
      key_words: Object,
      communProblems: String,

      intervalId: null,
      messageIndex: 0,
      messages: [
        'Carregando os dados de reviews do Google...',
        'Palavras-chave em Alta e Problemas Comuns serão processados com Machine Learning e Inteligência Artificial',
      ],
      showEstablishmentsModal: false,
      selectedCategory: null,
      establishmentsData: {
        positive: [],
        neutral: [],
        negative: []
      },
      selectedCategoryFilter: null,
      chartsInitialized: false,
      showTrendsModal: false,
      selectedSectorForTrends: '',
      sectorTrendsData: {
        yearlyTrend: [],
        yearlyGrowth: [],
        monthlySeasonal: [],
        correlations: []
      },
      showActionPlanModal: false,
      selectedCategoryForAction: '',
      selectedCategoryNameForAction: '',
      selectedMonthForAction: 1,
      selectedYearForAction: 2023,
      selectedMapButton: 'mostRated',
    }
  },
  layout: Layout,
  components: {
    Skeleton,
    Toast,
    SidebarMapData,
    ReviewsInsights,
    StateCitySelector,
    EstablishmentsModal,
    TrendsModal,
    ActionPlanModal,
  },
  props: {
    citiesString: String,
    roleId: Number,
  },
  mounted() {
    this.searchLocation()
    this.getStates()
  },
  watch: {
    isLoadingReviews(newValue) {
      if (newValue === false) {
        setTimeout(() => {
          if (!this.chartsInitialized) {
            this.initializeCharts()
          }
          this.getKeyWords()
        }, 300)
      }
    }
  },
  methods: {
    async getStates() {
      try {
        this.loadingStates = true
        const response = await axios.get('/api/states')
        this.states = response.data
      } catch (error) {
        this.loadingStates = false
        console.log(error)
      } finally {
        this.loadingStates = false
      }
    },
    handleCityUpdate(newCity) {
      this.selectedCity = newCity
    },
    async getComunsProblems() {
      const reviews = {
        gastronomy: this.gastronomy,
        lodging: this.lodging,
        tour: this.tour,
        transport: this.transport,
        nightlife: this.nightlife,
        commerce: this.commerce,
      }
      try {
        this.isLoadingComunsProblems = true
        const reponse = await axios.post('/api/reviews/comuns-problems', {
          citiesString: this.citiesStringData
        })
        this.communProblems = reponse.data.communProblems
        if (reponse.data.communProblems) {
          this.communProblemsArray = reponse.data.communProblems.filter((item) => item.quantity > 1)

          // Ordena o array filtrado
          this.communProblemsArray.sort((a, b) => b.quantity - a.quantity)
        }
        setTimeout(() => {
          this.isLoadingComunsProblems = false
        }, 1000)
      } catch (error) {
      }
    },
    async getKeyWords() {
      const reviews = {
        gastronomy: this.gastronomy,
        lodging: this.lodging,
        tour: this.tour,
        transport: this.transport,
        nightlife: this.nightlife,
        commerce: this.commerce,
      }
      try {
        this.isLoadingKeyWords = true
        const reponse = await axios.post('/api/reviews/process', {
          citiesString: this.citiesStringData
        })
        this.key_words = reponse.data.key_words
        setTimeout(() => {
          this.isLoadingKeyWords = false
          this.getComunsProblems()
        }, 1000)
      } catch (error) {}
    },
    async getReviewsByPlaces() {
      const updateReviews = (category, responseData) => {
        Object.keys(responseData[category]).forEach((dataKey) => {
          const dataItem = responseData[category][dataKey]
          this[category].forEach((data, index) => {
            if (data.id === dataItem.business_id) {
              this[category].average_data = responseData[category].average_data
              this[category][index].reviews.push({ ...dataItem })
            }
          })
        })
      }

      try {
        this.isLoadingReviews = true

        const response = await axios.post('/api/reviews/by-places', {
          citiesString: this.citiesStringData,
          places: {
            commerce: this.commerce,
            nightlife: this.nightlife,
            transport: this.transport,
            tour: this.tour,
            gastronomy: this.gastronomy,
            lodging: this.lodging,
          },
        })
        ;['commerce', 'nightlife', 'transport', 'tour', 'gastronomy', 'lodging'].forEach(
          (category) => {
            updateReviews(category, response.data)
          },
        )
        
        // Buscar todos os anos disponíveis nos dados mensais
        this.findAvailableYears()
        
        // Definir isLoadingReviews como falso APÓS processar todos os dados
        this.isLoadingReviews = false
      } catch (error) {
        console.error(error)
        this.isLoadingReviews = false
      }
    },
    async searchLocation(citiesString) {
      try {
        this.isLoading = true
        const reponse = await axios.post('/api/reviews', {
          citiesString: this.citiesStringData,
        })
        this.gastronomy = reponse.data.gastronomy
        this.lodging = reponse.data.lodging
        this.tour = reponse.data.tour
        this.transport = reponse.data.transport
        this.nightlife = reponse.data.nightlife
        this.commerce = reponse.data.commerce
        this.query_date = reponse.data.query_date
        this.predominantSentiment = reponse.data.predominant_sentiment
        this.isLoading = false
        setTimeout(() => {
          // Criar apenas o mapa inicial baseado no selectedMapButton
          if (this.selectedMapButton === 'all') {
            this.createMap();
          } else if (this.selectedMapButton === 'mostRated') {
            this.createSecondMap();
          }
          this.getReviewsByPlaces(citiesString)
        }, 1500)
      } catch (error) {
        console.log('Erro ao buscar os dados de reviews: ', error)
      } finally {
      }
    },
    selectChartButton(button) {
      // Definir qual botão está selecionado
      this.selectedChartButton = button;
      
      // Usar nextTick para garantir que o DOM foi atualizado após a mudança de selectedChartButton
      this.$nextTick(() => {
        // Recriar o gráfico apropriado com base no botão selecionado
        if (button === 'myChartYearly') {
          this.createChartYearly();
        } else if (button === 'myChartMonthly') {
          this.createChartMonthly(this.selectedYearMonthly);
        }
      });
    },
    selectMapButton(button) {
      // Destruir os mapas existentes de forma segura
      const mapElement = document.getElementById('map');
      const secondMapElement = document.getElementById('secondMap');
      
      if (mapElement && mapElement._leaflet_id) {
        mapElement._leaflet_id = null;
      }
      if (secondMapElement && secondMapElement._leaflet_id) {
        secondMapElement._leaflet_id = null;
      }

      // Atualizar o botão selecionado
      this.selectedMapButton = button;

      // Criar o novo mapa após um pequeno delay para garantir que o DOM foi atualizado
      setTimeout(() => {
        if (button === 'all') {
          this.createMap();
        } else if (button === 'mostRated') {
          this.createSecondMap();
        }
      }, 100);
    },
    createChartYearly() {
      const canvas = document.getElementById('myChartYearly')
      if (!canvas) {
        console.error("Canvas element 'myChartYearly' not found.")
        return
      }
      
      const canvas2 = document.getElementById('myChartMonthly')
      if (canvas2 && canvas2.chart) {
        canvas2.chart.destroy()
      }
      
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        console.error("Could not get 2D context for 'myChartYearly'.")
        return
      }
      
      // Destruir o gráfico anterior se existir
      if (canvas.chart) {
        canvas.chart.destroy()
      }

      canvas.width = 1100
      canvas.height = 300

      const labelsToRender = [
        'Gastronomia',
        'Hospedagem',
        'Atrações Turísticas',
        'Transporte',
        'Vida Noturna',
        'Comércio',
      ]
      const labelsForData = ['gastronomy', 'lodging', 'tour', 'transport', 'nightlife', 'commerce']

      const datasets = [
        {
          label: '2021',
          data: [],
          backgroundColor: '#6CB9AD',
          borderWidth: 1,
          barThickness: 25,
        },
        {
          label: '2022',
          data: [],
          backgroundColor: '#324DDD',
          borderWidth: 1,
          barThickness: 25,
        },
        {
          label: '2023',
          data: [],
          backgroundColor: '#9747FF',
          borderWidth: 1,
          barThickness: 25,
        },
        {
          label: '2024',
          data: [],
          backgroundColor: '#A834FF',
          borderWidth: 1,
          barThickness: 25,
        },
        {
          label: '2025',
          data: [],
          backgroundColor: '#FF5733', // Nova cor para 2025: um tom de laranja
          borderWidth: 1,
          barThickness: 25,
        },
      ]

      // Preencher dados para cada ano em cada categoria
      labelsForData.forEach((category, categoryIndex) => {
        if (this[category] && this[category].average_data && this[category].average_data.average_yearly_ratings) {
          const yearlyRatings = this[category].average_data.average_yearly_ratings
          
          datasets.forEach((dataset, index) => {
            const year = dataset.label
            if (yearlyRatings[year]) {
              datasets[index].data[categoryIndex] = yearlyRatings[year]
            } else {
              datasets[index].data[categoryIndex] = 0
            }
          })
        } else {
          // Se não tiver dados para essa categoria, preencher com zeros
          datasets.forEach((dataset, index) => {
            datasets[index].data[categoryIndex] = 0
          })
        }
      })

      // Criar o gráfico
      canvas.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labelsToRender,
          datasets: datasets,
        },
        options: {
          responsive: false,
          maintainAspectRatio: true,
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Avaliação Média (0-5)'
              }
            },
            x: {
              title: {
                display: true,
                text: 'Categorias'
              }
            }
          },
          plugins: {
            legend: {
              display: true,
              position: 'top'
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const label = context.dataset.label || '';
                  const value = context.parsed.y || 0;
                  return `${label}: ${value.toFixed(1)}/5`;
                }
              }
            }
          },
          onClick: (e) => {
            const chart = canvas.chart;
            const points = chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
            
            if (points.length) {
              const firstPoint = points[0];
              const categoryIndex = firstPoint.index;
              const categoryName = labelsToRender[categoryIndex];
              const categoryKey = labelsForData[categoryIndex];
              
              // Abrir o modal de tendências em vez do modal de estabelecimentos
              // this.openTrendsModal(categoryKey, categoryName);
            }
          },
          onHover: (event, elements) => {
            // Mudar o cursor quando passar por cima das barras
            event.native.target.style.cursor = elements.length ? 'pointer' : 'default';
          }
        }
      })
    },
    createChartMonthly(selectedYear) {
      const canvas = document.getElementById('myChartMonthly')
      if (!canvas) {
        console.error("Canvas element 'myChartMonthly' not found.")
        return
      }
      
      const canvas2 = document.getElementById('myChartYearly')
      if (canvas2 && canvas2.chart) {
        canvas2.chart.destroy()
      }

      const ctx = canvas.getContext('2d')
      if (!ctx) {
        console.error("Could not get 2D context for 'myChartMonthly'.")
        return
      }
      
      // Destruir o gráfico anterior se existir
      if (canvas.chart) {
        canvas.chart.destroy()
      }

      canvas.width = 1100
      canvas.height = 300

      const monthNames = [
        'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez',
      ]

      const labelsForData = ['gastronomy', 'lodging', 'tour', 'transport', 'nightlife', 'commerce']
      const datasetColors = ['#6CB9AD', '#324DDD', '#9747FF', '#A834FF', '#F25362', '#FF9900']
      const datasetLabels = [
        'Gastronomia',
        'Hospedagem',
        'Atrações Turísticas',
        'Transporte',
        'Vida Noturna',
        'Comércio',
      ]

      // Usar o ano selecionado ou, se não definido, o ano atual
      const yearToShow = selectedYear || this.selectedYearMonthly || new Date().getFullYear()
      
      // Criar datasets para cada categoria
      const datasets = labelsForData.map((category, index) => {
        // Verifica se a categoria existe e se tem dados mensais para o ano selecionado
        const monthlyData = this[category]?.average_data?.['average_monthly_ratings']?.[yearToShow] || {}
        
        // Criar array com 12 posições (meses) preenchendo com os dados disponíveis
        const data = Array(12).fill(0).map((_, monthIndex) => {
          // O mês no backend começa em 1 (janeiro = 1)
          const monthNumber = monthIndex + 1
          return monthlyData[monthNumber] || 0
        })
        
        return {
          label: datasetLabels[index],
          data: data,
          backgroundColor: datasetColors[index],
          borderColor: datasetColors[index],
          borderWidth: 1,
          barThickness: 20,
        }
      })
      
      // Verifica se há pelo menos uma categoria com dados para criar o gráfico
      const hasData = datasets.some(dataset => dataset.data.some(value => value > 0))
      
      if (!hasData) {
        // Se não houver dados, exibe uma mensagem
        ctx.font = '16px Arial'
        ctx.fillText(
          `Não há dados mensais disponíveis para ${yearToShow}`,
          canvas.width / 2 - 150,
          canvas.height / 2
        )
        return
      }

      // Cria o gráfico com linhas e áreas
      canvas.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: monthNames,
          datasets: datasets
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          layout: {
            padding: {
              top: 10,
              right: 10,
              bottom: 10,
              left: 10
            }
          },
          interaction: {
            mode: 'index',
            intersect: false,
          },
          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Avaliação Média (0-5)'
              }
            },
            x: {
              title: {
                display: true,
                text: `Meses de ${yearToShow}`
              }
            }
          },
          plugins: {
            legend: {
              display: true,
              position: 'top'
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const label = context.dataset.label || '';
                  const value = context.parsed.y || 0;
                  return `${label}: ${value.toFixed(1)}/5`;
                }
              }
            }
          },
          onClick: (e) => {
            const chart = canvas.chart;
            const points = chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
            
            if (points.length) {
              const firstPoint = points[0];
              const monthIndex = firstPoint.index;
              const month = monthIndex + 1; // Ajustar para o formato do mês (1-12)
              const year = this.selectedYearMonthly || new Date().getFullYear();
              const datasetIndex = firstPoint.datasetIndex;
              const categoryName = datasets[datasetIndex].label;
              const categoryKey = labelsForData[datasetIndex];
              
              // Abrir o modal de plano de ação
              // this.openActionPlanModal(categoryKey, categoryName, month, year);
            }
          },
          onHover: (event, elements) => {
            // Mudar o cursor quando passar por cima dos pontos
            event.native.target.style.cursor = elements.length ? 'pointer' : 'default';
          },
          animations: {
            // ... animações existentes
          }
        }
      })
    },
    selectYearMonthly(year) {
      this.selectedYearMonthly = year
      this.createChartMonthly(year)
    },
    findAvailableYears() {
      // Buscar todos os anos disponíveis nos dados mensais
      const years = new Set()
      
      const categories = ['gastronomy', 'lodging', 'tour', 'transport', 'nightlife', 'commerce']
      
      categories.forEach(category => {
        if (this[category]?.average_data?.['average_monthly_ratings']) {
          Object.keys(this[category].average_data['average_monthly_ratings']).forEach(year => {
            years.add(parseInt(year))
          })
        }
      })
      
      // Ordenar os anos em ordem decrescente (mais recente primeiro)
      this.availableYears = Array.from(years).sort((a, b) => b - a)
      
      // Se não houver anos nos dados, adicione o ano atual
      if (this.availableYears.length === 0) {
        this.availableYears.push(new Date().getFullYear())
      }
      
      // Atualizar o ano selecionado para o mais recente disponível
      this.selectedYearMonthly = this.availableYears[0]
    },
    getMonthNames(label) {
      switch (label) {
        case '1':
          return 'Jan'
        case '2':
          return 'Fev'
        case '3':
          return 'Mar'
        case '4':
          return 'Abr'
        case '5':
          return 'Mai'
        case '6':
          return 'Jun'
        case '7':
          return 'Jul'
        case '8':
          return 'Ago'
        case '9':
          return 'Set'
        case '10':
          return 'Out'
        case '11':
          return 'Nov'
        case '12':
          return 'Dez'
      }
    },
    createSecondChart() {
      const canvas = document.getElementById('secondChart')
      if (!canvas) {
        console.error("Canvas element 'secondChart' not found.")
        return
      }
      
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        console.error("Could not get 2D context for 'secondChart'.")
        return
      }
      
      // Destruir o gráfico anterior se existir
      if (canvas.chart) {
        canvas.chart.destroy()
      }
      
      canvas.width = 1100
      canvas.height = 400
      
      const getColor = (rating) => {
        if (rating >= 4) {
          return '#0B8C0B'
        } else if (rating >= 2 && rating < 4) {
          return '#FFC700'
        } else {
          return '#F25362'
        }
      }
      
      const categories = ['gastronomy', 'lodging', 'tour', 'transport', 'nightlife', 'commerce']
      const categoryLabels = [
        'Gastronomia',
        'Hospedagem',
        'Atrações Turisticas',
        'Transporte',
        'Vida Noturna',
        'Comércio',
      ]
      
      // Verificar se temos dados para mostrar
      const hasData = categories.some(category => 
        this[category] && this[category].average_data && 
        typeof this[category].average_data['average_ratings'] !== 'undefined'
      )
      
      if (!hasData) {
        // Se não houver dados, exibe uma mensagem
        ctx.font = '16px Arial'
        ctx.fillText(
          'Não há dados disponíveis para exibir',
          canvas.width / 2 - 150,
          canvas.height / 2
        )
        return
      }
      
      const chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: categoryLabels,
          datasets: [
            {
              label: 'Avaliação',
              data: [
                this.gastronomy?.average_data['average_ratings'] || 0,
                this.lodging?.average_data['average_ratings'] || 0,
                this.tour?.average_data['average_ratings'] || 0,
                this.transport?.average_data['average_ratings'] || 0,
                this.nightlife?.average_data['average_ratings'] || 0,
                this.commerce?.average_data['average_ratings'] || 0,
              ],

              backgroundColor: [
                getColor(this.gastronomy?.average_data['average_ratings'] || 0),
                getColor(this.lodging?.average_data['average_ratings'] || 0),
                getColor(this.tour?.average_data['average_ratings'] || 0),
                getColor(this.transport?.average_data['average_ratings'] || 0),
                getColor(this.nightlife?.average_data['average_ratings'] || 0),
                getColor(this.commerce?.average_data['average_ratings'] || 0),
              ],
              borderWidth: 1,
              barThickness: 30,
            },
          ],
        },
        options: {
          indexAxis: 'y',
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              callbacks: {
                title: function(tooltipItems) {
                  const index = tooltipItems[0].dataIndex;
                  return categoryLabels[index];
                },
                label: function(context) {
                  return `Avaliação: ${context.parsed.x.toFixed(1)}`;
                }
              }
            }
          },
          scales: {
            x: {
              display: true,
              beginAtZero: true,
              ticks: {
                display: false,
              },
              title: {
                display: false,
              },
            },
            y: {
              display: true,
              beginAtZero: true,
              title: {
                display: false,
              },
            },
          },
          onClick: (e) => {
            const points = chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);
            
            if (points.length) {
              const firstPoint = points[0];
              const index = firstPoint.index;
              const categoryName = categories[index];
              
              // Abrir modal com a categoria selecionada
              this.selectedCategoryFilter = categoryName;
              this.selectedCategory = 'positive'; // Define um filtro padrão quando abre pelo gráfico
              this.showEstablishmentsModal = true;
              this.organizeEstablishmentsWithFilters();
            }
          },
          onHover: (event, elements) => {
            // Mudar o cursor quando passar por cima das barras
            event.native.target.style.cursor = elements.length ? 'pointer' : 'default';
          }
        },
      })
    },
    createSecondMap() {
      const mapElement = document.getElementById('secondMap');
      if (!mapElement) {
        console.error("Element 'secondMap' not found");
        return;
      }

      // Destruir o mapa anterior se existir
      if (mapElement._leaflet_id) {
        mapElement._leaflet_id = null;
      }

      const filteredLocation = [];
      const categories = ['gastronomy', 'lodging', 'tour', 'transport', 'nightlife', 'commerce'];
      categories.forEach((category) => {
        const categoryData = this[category];
        if (categoryData) {
          Object.values(categoryData).forEach((item) => {
            const { location, rating } = item;
            if (location && rating >= 4) {
              filteredLocation.push([location.lat, location.lng]);
            }
          });
        }
      });
      const center = filteredLocation.length > 0 ? filteredLocation[0] : [-37.87, 175.475];
      const zoom = 13;

      const map = L.map('secondMap').setView(center, zoom);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map);
      L.heatLayer(filteredLocation, {
        radius: 25,
        blur: 20,
        maxZoom: 5,
        max: 5,
        gradient: {
          0.1: 'blue',
          0.2: 'cyan',
          0.4: 'lime',
          0.6: 'yellow',
          0.8: 'orange',
          1: 'red',
        },
      }).addTo(map);
    },
    createMap() {
      const mapElement = document.getElementById('map');
      if (!mapElement) {
        console.error("Element 'map' not found");
        return;
      }

      // Destruir o mapa anterior se existir
      if (mapElement._leaflet_id) {
        mapElement._leaflet_id = null;
      }

      let map;
      if (this.lodging && Object.keys(this.lodging).length > 0) {
        const firstAccommodation = Object.values(this.lodging)[0];
        const { lat, lng } = firstAccommodation.location;
        map = L.map('map').setView([lat, lng], 13);
      } else {
        map = L.map('map').setView([-14.235004, -51.92528], 13);
      }

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map);

      const categories = ['gastronomy', 'lodging', 'tour', 'transport', 'nightlife', 'commerce'];

      categories.forEach((category) => {
        const categoryData = this[category];
        if (categoryData) {
          Object.entries(categoryData).forEach(([key, item]) => {
            const { location } = item;
            if (location) {
              const { lat, lng } = location;
              const marker = L.marker([lat, lng]).addTo(map).bindPopup(item.name);
              marker.on('click', () => {
                this.reviewData = item;
                this.isSidebarMapDataOpen = true;
              });
            }
          });
        }
      });
    },
    openEstablishmentsModal(sentiment) {
      this.selectedCategory = sentiment
      this.showEstablishmentsModal = true
      this.organizeEstablishmentsBySentiment()
    },
    closeEstablishmentsModal() {
      this.showEstablishmentsModal = false
      this.selectedCategory = null
      this.selectedCategoryFilter = null
    },
    clearCategoryFilter() {
      this.selectedCategoryFilter = null
      this.organizeEstablishmentsWithFilters()
    },
    organizeEstablishmentsBySentiment() {
      const categories = ['gastronomy', 'lodging', 'tour', 'transport', 'nightlife', 'commerce']
      this.establishmentsData = {
        positive: [],
        neutral: [],
        negative: []
      }

      categories.forEach(category => {
        if (this[category]) {
          this[category].forEach(establishment => {
            if (establishment.rating >= 4) {
              this.establishmentsData.positive.push({
                ...establishment,
                category
              })
            } else if (establishment.rating >= 2) {
              this.establishmentsData.neutral.push({
                ...establishment,
                category
              })
            } else {
              this.establishmentsData.negative.push({
                ...establishment,
                category
              })
            }
          })
        }
      })
    },
    organizeEstablishmentsWithFilters() {
      const categories = ['gastronomy', 'lodging', 'tour', 'transport', 'nightlife', 'commerce']
      this.establishmentsData = {
        positive: [],
        neutral: [],
        negative: []
      }

      categories.forEach(category => {
        // Se tiver um filtro de categoria e não for a categoria selecionada, pula
        if (this.selectedCategoryFilter && category !== this.selectedCategoryFilter) {
          return
        }
        
        if (this[category]) {
          this[category].forEach(establishment => {
            if (establishment.rating >= 4) {
              this.establishmentsData.positive.push({
                ...establishment,
                category
              })
            } else if (establishment.rating >= 2) {
              this.establishmentsData.neutral.push({
                ...establishment,
                category
              })
            } else {
              this.establishmentsData.negative.push({
                ...establishment,
                category
              })
            }
          })
        }
      })
      
      // Se não houver dados no sentimento selecionado, tenta encontrar um que tenha
      if (this.selectedCategory && this.establishmentsData[this.selectedCategory].length === 0) {
        // Verifica cada sentimento para encontrar um com dados
        const sentiments = ['positive', 'neutral', 'negative'];
        for (const sentiment of sentiments) {
          if (this.establishmentsData[sentiment].length > 0) {
            this.selectedCategory = sentiment;
            break;
          }
        }
      }
    },
    initializeCharts() {
      // Verificar se os elementos canvas existem no DOM
      const yearlyCanvas = document.getElementById('myChartYearly')
      const monthlyCanvas = document.getElementById('myChartMonthly')
      
      if (!yearlyCanvas || !monthlyCanvas) {
        console.log('Canvas elements not found, will try again later')
        return
      }
      
      // Criar os gráficos
      this.createChartYearly()
      this.createChartMonthly(this.selectedYearMonthly)
      this.createSecondChart()
      
      // Buscar as informações adicionais
      this.getKeyWords()
      
      // Marcar que os gráficos foram inicializados
      this.chartsInitialized = true
    },
    forceChartDisplay() {
      // Forçar a renderização do gráfico anual assim que esta imagem invisível for carregada
      setTimeout(() => {
        this.createChartYearly();
        // Garantir que o gráfico anual seja exibido
        this.selectedChartButton = 'myChartYearly';
        // Marcar como inicializado
        this.chartsInitialized = true;
      }, 0);
    },
    forceSecondChartDisplay() {
      // Forçar a renderização do segundo gráfico assim que a imagem invisível for carregada
      setTimeout(() => {
        try {
          this.createSecondChart();
        } catch (error) {
          console.error("Error creating second chart:", error);
        }
      }, 100); // Dar um pouco mais de tempo
    },
    openTrendsModal(category, displayName) {
      // Preparar os dados para o modal
      this.prepareTrendsData(category, displayName);
      
      // Abrir o modal
      this.showTrendsModal = true;
      this.selectedSectorForTrends = displayName;
    },
    
    closeTrendsModal() {
      this.showTrendsModal = false;
      this.selectedSectorForTrends = '';
    },
    
    prepareTrendsData(category, displayName) {
      // Verificar se a categoria existe
      if (!this[category]) {
        console.warn(`Categoria ${category} não encontrada.`);
        // Fornecer dados vazios para evitar erros
        this.sectorTrendsData = {
          yearlyTrend: [],
          yearlyGrowth: [],
          monthlySeasonal: [],
          correlations: []
        };
        return;
      }
      
      // Obter dados anuais
      const yearlyData = [];
      const years = ['2021', '2022', '2023', '2024', '2025'];
      
      if (this[category] && 
          this[category].average_data && 
          this[category].average_data['average_yearly_ratings']) {
            
        const yearlyRatings = this[category].average_data['average_yearly_ratings'];
        
        years.forEach(year => {
          yearlyData.push({
            year: year,
            rating: yearlyRatings[year] || 0
          });
        });
      } else {
        // Se não houver dados, criar dados vazios para cada ano
        years.forEach(year => {
          yearlyData.push({
            year: year,
            rating: 0
          });
        });
      }
      
      // Calcular crescimento anual (variação percentual)
      const yearlyGrowth = [];
      for (let i = 1; i < yearlyData.length; i++) {
        if (yearlyData[i-1].rating > 0) {
          const growth = ((yearlyData[i].rating - yearlyData[i-1].rating) / yearlyData[i-1].rating) * 100;
          yearlyGrowth.push({
            period: `${yearlyData[i-1].year} → ${yearlyData[i].year}`,
            growth: growth.toFixed(1),
            rating: yearlyData[i].rating
          });
        } else {
          yearlyGrowth.push({
            period: `${yearlyData[i-1].year} → ${yearlyData[i].year}`,
            growth: 'N/A', // Não é possível calcular crescimento a partir de zero
            rating: yearlyData[i].rating
          });
        }
      }
      
      // Dados de sazonalidade mensal para o ano atual
      const monthlySeasonal = [];
      const currentYear = new Date().getFullYear();
      const monthNames = this.getMonthNames();
      
      if (this[category] && 
          this[category].average_data && 
          this[category].average_data['average_monthly_ratings'] &&
          this[category].average_data['average_monthly_ratings'][currentYear]) {
        
        const monthlyRatings = this[category].average_data['average_monthly_ratings'][currentYear];
        
        for (let month = 1; month <= 12; month++) {
          monthlySeasonal.push({
            month: monthNames[month-1],
            rating: monthlyRatings[month] || 0
          });
        }
      } else {
        // Se não houver dados mensais, criar dados vazios para cada mês
        for (let month = 1; month <= 12; month++) {
          monthlySeasonal.push({
            month: monthNames[month-1],
            rating: 0
          });
        }
      }
      
      // Exemplos de dados de correlação (simulados)
      // Na prática, estes dados viriam de uma análise mais profunda ou API específica
      const correlations = [
        { 
          event: 'Feira Gastronômica',
          correlation: 0.85, 
          impact: 'Forte positiva',
          month: 'Março'
        },
        { 
          event: 'Festival de Inverno',
          correlation: 0.72, 
          impact: 'Positiva',
          month: 'Julho'
        },
        { 
          event: 'Temporada de Chuvas',
          correlation: -0.64, 
          impact: 'Negativa',
          month: 'Janeiro'
        },
        { 
          event: 'Férias Escolares',
          correlation: 0.79, 
          impact: 'Forte positiva',
          month: 'Dezembro/Janeiro'
        }
      ];
      
      // Atualizar os dados para o modal
      this.sectorTrendsData = {
        yearlyTrend: yearlyData,
        yearlyGrowth: yearlyGrowth,
        monthlySeasonal: monthlySeasonal,
        correlations: correlations
      };
    },
    
    // Método auxiliar para obter nomes dos meses
    getMonthNames(month) {
      const months = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 
        'Maio', 'Junho', 'Julho', 'Agosto', 
        'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ];
      
      if (month) {
        // Ajustar para índice base-0
        const index = parseInt(month) - 1;
        return (index >= 0 && index < 12) ? months[index] : '';
      }
      
      return months;
    },
    openActionPlanModal(categoryKey, categoryName, month, year) {
      this.selectedCategoryForAction = categoryKey;
      this.selectedCategoryNameForAction = categoryName;
      this.selectedMonthForAction = month;
      this.selectedYearForAction = year;
      this.showActionPlanModal = true;
    },
    closeActionPlanModal() {
      this.showActionPlanModal = false;
    },
    getEstablishmentsCount() {
      if (!this.reviews || this.reviews.length === 0) return 0;
      
      // Filtra reviews pela data selecionada
      const filteredReviews = this.reviews.filter(review => {
        const reviewDate = new Date(review.time_created);
        return reviewDate >= this.startDate && reviewDate <= this.endDate;
      });

      // Cria um Set com os IDs únicos de estabelecimentos que têm reviews
      const uniqueEstablishmentIds = new Set(filteredReviews.map(review => review.establishment_id));
      
      return uniqueEstablishmentIds.size;
    },
  },
}
</script>

<style src="./styles.scss" lang="scss">
.btn-year {
  padding: 6px 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  transition: all 0.2s ease;
}

.btn-year:hover {
  background: #e2e8f0;
}

.btn-year.selected {
  background: #324DDD;
  color: white;
  border-color: #324DDD;
}
</style>
